import { PaymentMethod } from '@entities/payment'
import { checkIsAnotherOperator, checkIsMtsClient, getMtsBinding } from '@entities/user'
import { Binding } from '@root/api/ump-plat-sdk-gateway'

interface checkIsPaymentAvailableArgs {
  paymentMethod: PaymentMethod
  bindings: Binding[]
  phone: string
  isAuth: boolean
  paymentBanMTS: boolean
  operatorMTS: boolean
  errorOperatorInfo: boolean | null
}

export const checkIsPaymentAvailable = ({
  paymentMethod,
  bindings,
  phone,
  isAuth,
  paymentBanMTS,
  operatorMTS,
  errorOperatorInfo,
}: checkIsPaymentAvailableArgs): boolean => {
  const mtsBinding = getMtsBinding(bindings)
  const isMtsClient = checkIsMtsClient(bindings, isAuth, operatorMTS, paymentBanMTS)
  const isAnotherOperator = checkIsAnotherOperator(isAuth, phone, operatorMTS, errorOperatorInfo)

  const isMtsPaymentAvailable = isMtsClient && mtsBinding?.balance !== undefined

  if (paymentMethod === PaymentMethod.SBP) {
    return true
  }

  return isMtsPaymentAvailable && !isAnotherOperator
}
